module.exports = __webpack_public_path__ + "static/media/12ste[.9f888674.svg";